import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { GiftEdit } from './types'
import { $params } from '../../../../features/router'
import { getGiftsCategories } from '../../giftsCategories/list/model'
import { buildDisplayRequirements, getMinVersions } from '../utils'

export const giftMounted = createEvent()
export const setGift = createEvent<GiftEdit>()
export const submitEditGift = createEvent<GiftEdit>()
export const $gift = restore(setGift, {
  id: 0,
  name: '',
  title: '',
  description: '',
  imageSmall: '',
  imageMedium: '',
  imageLarge: '',
  categoryId: 0,
  price: 0,
  costPrice: 0,
  availableNumber: 0,
  availableCountries: [],
  isShow: false,
  giftType: 'GIFT_TYPE_UNKNOWN',
  label: '',
  downloadUrl: '',
  sorting: 0,
  conversion: {
    target_amount: 0,
    min_crowns_amount: 0,
  },
  bonusReview: {
    platform_name: '',
    platform_title: '',
    platform_link: '',
  },
  displayRequirements: null,
  versionMinIos: '',
  versionMinAndroid: '',
})

export const giftCategoriesList = createEvent()

export const getGift = fx<void, GiftEdit>({
  method: 'GET',
  url: '/giftshop/gift/',
})

export const updateGift = fx<GiftEdit, GiftEdit>({
  method: 'POST',
  url: '/giftshop/gift/',
})

sample({
  clock: giftMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.giftID
    }
    return {
      url: `/giftshop/gift/${id}`,
    }
  },
  target: getGift,
})

sample({
  clock: [getGift.doneData, updateGift.doneData],
  fn: (doneData) => ({
    ...doneData.body,
    ...getMinVersions(doneData.body.displayRequirements),
    giftType: doneData.body.giftType ?? 'GIFT_TYPE_UNKNOWN',
  }),
  target: [setGift],
})

sample({
  //@ts-ignore
  clock: submitEditGift,
  source: $params,
  fn: (params, gift) => {
    const { versionMinIos, versionMinAndroid, ...giftFields } = gift

    return {
      url: `/giftshop/gift/${params?.giftID}`,
      formData: {
        ...giftFields,
        giftCategory: gift.categoryId,
        conversion: JSON.stringify(gift.conversion),
        bonusReview: gift.bonusReview ? JSON.stringify(gift.bonusReview) : null,
        displayRequirements: buildDisplayRequirements(
          versionMinIos,
          versionMinAndroid,
        ),
      },
    }
  },
  target: updateGift,
})

sample({
  // @ts-ignore
  clock: giftCategoriesList,
  target: getGiftsCategories,
})
